import React from 'react';
import ModalCommon from "../ModalCommon";
import PopupCreateNote from "../PopupNotes/components/PopupCreateNote/PopupCreateNote";
import Note from "./components/Note/Note";
import Empty from "../Empty";
import {usePopupNotesContext} from './contexts/PopupNotesContext';
import styles from './styles.module.scss';
import icon from "../../assets/provision.svg";

const PopupNotes = ({firmShumaID}) => {
  const {
    createNote,
    resetNoteDetails,
    loading,
    list,
    updateList,
    disabled,
    formik,
    getOptions
  } = usePopupNotesContext();

  const headers = ['#', 'תאריך יצירה', 'סטטוס', 'פירוט', 'תאריך לביצוע (יעד)', 'יוצר', 'גורם מטפל', ''];
  const mapHeaders = (text, index) => <div className={styles.headerCell} key={index}>{text}</div>;
  const mapNotes = (item, index) => <Note key={index} {...item}/>;

  const handleSubmit = async () => {
    await createNote(
      formik.values.statusTypeID,
      formik.values.dueDate,
      formik.values.responsibleUserID,
      formik.values.freeText,
    );
    formik.resetForm();
    await updateList();
  };

  return (
    <ModalCommon
      size={'xl'}
      header={['עדכונים לבדיקה', firmShumaID].filter(Boolean).join(' - ')}
      customModalTrigger={
        <div className={styles.triggerContainer} onClick={updateList}>
          <img src={icon} alt="i"/>
          <span>{'עדכונים לבדיקה'}</span>
        </div>
      }
      customActionButton={
        <PopupCreateNote
          onEdit={handleSubmit}
          onOpen={() => {
            resetNoteDetails();
            getOptions();
          }}
          disabled={disabled}
        />
      }
    >
      <div className={styles.header}>{headers.map(mapHeaders)}</div>
      {(list.length === 0 && !loading)
        ? <Empty message={'אין משימות'} customContainerClassName={styles.empty}/>
        : (
          <div className={styles.list}>
            {list
              .sort((a, b) => new Date(b?.createDate) - new Date(a?.createDate))
              .map(mapNotes)
            }
          </div>
        )
      }
    </ModalCommon>
  );
};

export default PopupNotes;